import React from 'react';
import './JobModal.css';
import { FaMapMarkerAlt, FaTag, FaTimes } from 'react-icons/fa';

const JobModal = ({ job, closeModal }) => {
  // Helper to ensure a value is an array; if it's a string, split it by newline.
  const toArray = (value) => {
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      // Split by newline and filter out empty lines.
      return value
        .split('\n')
        .map((s) => s.trim())
        .filter((s) => s);
    }
    return [];
  };

  const responsibilities = toArray(job.responsibilities);
  const requirements = toArray(job.requirements || job.requirments); // In case the field is misspelled.
  const benefits = toArray(job.benefits);

  return (
    <div className='modal' onClick={closeModal}>
      <div
        className='modal-content'
        onClick={(e) => e.stopPropagation()}
        role='dialog'
        aria-modal='true'
        aria-labelledby='job-modal-title'
      >
        <button className='close-btn' onClick={closeModal} aria-label='Close'>
          <FaTimes />
        </button>
        <div className='modal-header'>
          <h2 className='modal-title' id='job-modal-title'>
            {job.title}
          </h2>
          <div className='modal-meta'>
            <span className='modal-location'>
              <FaMapMarkerAlt className='modal-icon' />
              {toArray(job.location).join(', ')}
            </span>
            <span className='modal-category'>
              <FaTag className='modal-icon' />
              {toArray(job.category).join(', ')}
            </span>
          </div>
        </div>
        <div className='modal-body'>
          {job.description && (
            <div className='modal-section'>
              <p className='modal-description'>{job.description}</p>
            </div>
          )}
          {responsibilities.length > 0 && (
            <div className='modal-section'>
              <h3 className='section-title'>תחומי אחריות</h3>
              <ul className='modal-list'>
                {responsibilities.map((item, index) => (
                  <li className='modal-list-item' key={index}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {requirements.length > 0 && (
            <div className='modal-section'>
              <h3 className='section-title'>דרישות התפקיד</h3>
              <ul className='modal-list'>
                {requirements.map((req, index) => (
                  <li className='modal-list-item' key={index}>
                    {req}
                  </li>
                ))}
              </ul>
            </div>
          )}
          {benefits.length > 0 && (
            <div className='modal-section'>
              <h3 className='section-title'>הטבות</h3>
              <ul className='modal-list'>
                {benefits.map((benefit, index) => (
                  <li className='modal-list-item' key={index}>
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className='modal-footer'>
          <a
            className='modal-link'
            href={job.link}
            target='_blank'
            rel='noopener noreferrer'
          >
            <button className='modal-apply-btn'>הגשת מועמדות</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default JobModal;

// // JobModal.js
// import React from 'react';
// import './JobModal.css';
// import { FaMapMarkerAlt, FaTag, FaTimes } from 'react-icons/fa';

// const JobModal = ({ job, closeModal }) => {
//   // Helper function to ensure value is an array
//   const toArray = (value) => (Array.isArray(value) ? value : [value]);

//   return (
//     <div className='modal' onClick={closeModal}>
//       <div
//         className='modal-content'
//         onClick={(e) => e.stopPropagation()}
//         role='dialog'
//         aria-modal='true'
//         aria-labelledby='job-modal-title'
//       >
//         <button className='close-btn' onClick={closeModal} aria-label='Close'>
//           <FaTimes />
//         </button>
//         <div className='modal-header'>
//           <h2 className='modal-title' id='job-modal-title'>
//             {job.title}
//           </h2>
//           <div className='modal-meta'>
//             <span className='modal-location'>
//               <FaMapMarkerAlt className='modal-icon' />
//               {toArray(job.location).join(', ')}
//             </span>
//             <span className='modal-category'>
//               <FaTag className='modal-icon' />
//               {toArray(job.category).join(', ')}
//             </span>
//           </div>
//         </div>
//         <div className='modal-body'>
//           {job.description && (
//             <div className='modal-section'>
//               <p className='modal-description'>{job.description}</p>
//             </div>
//           )}
//           {job.responsibilities && (
//             <div className='modal-section'>
//               <h3 className='section-title'>תחומי אחריות</h3>
//               <ul className='modal-list'>
//                 {job.responsibilities.map((item, index) => (
//                   <li className='modal-list-item' key={index}>
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//           {job.requirements && (
//             <div className='modal-section'>
//               <h3 className='section-title'>דרישות התפקיד</h3>
//               <ul className='modal-list'>
//                 {job.requirements.map((requirement, index) => (
//                   <li className='modal-list-item' key={index}>
//                     {requirement}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//           {job.benefits && (
//             <div className='modal-section'>
//               <h3 className='section-title'>הטבות</h3>
//               <ul className='modal-list'>
//                 {job.benefits.map((benefit, index) => (
//                   <li className='modal-list-item' key={index}>
//                     {benefit}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>
//         <div className='modal-footer'>
//           <a
//             className='modal-link'
//             href={job.link}
//             target='_blank'
//             rel='noopener noreferrer'
//           >
//             <button className='modal-apply-btn'>הגשת מועמדות</button>
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default JobModal;
